module.exports = __webpack_public_path__ + "static/media/radio-alt.b36a1cb7.svg";